import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { mentorsityLogo } from '../assets/event-logos';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { IoLocationOutline } from 'react-icons/io5';
import { RiSparklingFill } from 'react-icons/ri';
import homepageImg from '../assets/homepage.png';
import visionImg from '../assets/vision.png';
import { FaHandshake, FaNetworkWired, FaUsers, FaBuilding, FaMicrophone, FaPhone, FaEnvelope, FaCalendarAlt, FaRocket, FaLightbulb } from 'react-icons/fa';
import { MdOutlineContactSupport } from 'react-icons/md';
import { IoIosGlobe } from 'react-icons/io';
// Import speaker images
import riyaImg from '../assets/riya.G.png';
import anujImg from '../assets/Anuj.png';
import gauravImg from '../assets/Gaurav.png';
import khalidImg from '../assets/Khalid.png';
// Import media partner logos
import toiLogo from '../assets/toi.png';
import hindustanTimesLogo from '../assets/hindustan-times.png';
import dainikLogo from '../assets/dainik-removebg.png';
import dailyhuntLogo from '../assets/dailyhunt.png';
import zeeLogo from '../assets/zee.png';
import indianTimesLogo from '../assets/indian-Times.png';
import startupLogo from '../assets/stratup.png';
import qnaLogo from '../assets/qna.png';
import vcLogo from '../assets/vc.png';
import edtimesLogo from '../assets/edtimes.png';
import helloEntrepreneurLogo from '../assets/hello-entrepreneurse.png';
import aniNewsLogo from '../assets/ani-news.png';
// Import contact image

// Define new color scheme
const COLORS = {
    primary: '#000000',     // Black
    secondary: '#6464ad',   // Purple
    accent1: '#d9daee',     // Light Lavender
    accent2: '#afadd5',     // Medium Lavender
    accent3: '#6464ad',     // Same as secondary for consistency
    gradient1: 'linear-gradient(135deg, #000000 0%, #333333 100%)',
    gradient2: 'linear-gradient(135deg, #6464ad 0%, #afadd5 100%)',
};

const RiseupEvent = () => {
    const controls = useAnimation();
    const [logoSrc, setLogoSrc] = useState(mentorsityLogo);
    const [isRegistering, setIsRegistering] = useState(false);

    // Handle image loading error
    const handleImageError = () => {
        // Fallback to a placeholder logo if the original image fails to load
        setLogoSrc('https://via.placeholder.com/200x80/000000/FFFFFF?text=Mentorsity');
    };

    useEffect(() => {
        controls.start({
            opacity: 1,
            y: 0,
            transition: { duration: 0.8 }
        });
    }, [controls]);

    const handleRegisterClick = () => {
        setIsRegistering(true);
        setTimeout(() => setIsRegistering(false), 1000);
    };

    return (
        <div className="min-h-screen  relative overflow-hidden flex flex-col items-center justify-center ">
            {/* Main Hero Section with Dark Gradient */}
            <div className="w-full relative">
                {/* Dark gradient background - cover entire screen */}
                <div className="absolute inset-0 bg-gradient-to-b from-black to-[#333333] z-0"></div>

                {/* Decorative Elements */}
                <motion.div
                    className="absolute top-20 right-20 w-32 h-32 rounded-full border-2 border-[#6464ad]/30 z-10"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                />

                <motion.div
                    className="absolute bottom-20 left-20 w-24 h-24 rounded-full bg-[#6464ad]/10 z-10"
                    animate={{ scale: [1, 1.2, 1] }}
                    transition={{ duration: 4, repeat: Infinity }}
                />

                {/* Multiple decorative circles in bottom left corner */}
                <div className="absolute bottom-10 left-10 z-10">
                    <motion.div
                        className="relative w-40 h-40"
                    >
                        {/* Main circle with rotating border */}
                        <motion.div
                            className="absolute inset-0 rounded-full border-2 border-[#6464ad]"
                            animate={{ rotate: 360 }}
                            transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
                        ></motion.div>

                        {/* Orbit circles */}
                        <motion.div
                            className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-[#afadd5]/30"
                            animate={{ scale: [1, 1.3, 1] }}
                            transition={{ duration: 2, repeat: Infinity }}
                        />
                        <motion.div
                            className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-8 h-8 rounded-full bg-[#6464ad]/40"
                            animate={{ scale: [1, 1.2, 1] }}
                            transition={{ duration: 3, repeat: Infinity, delay: 0.5 }}
                        />
                        <motion.div
                            className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-white/30"
                            animate={{ scale: [1, 1.4, 1] }}
                            transition={{ duration: 2.5, repeat: Infinity, delay: 1 }}
                        />
                        <motion.div
                            className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-[#d9daee]/40"
                            animate={{ scale: [1, 1.3, 1] }}
                            transition={{ duration: 2.8, repeat: Infinity, delay: 0.7 }}
                        />

                        {/* Circular text */}
                        <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" style={{ overflow: 'visible' }}>
                            <defs>
                                <path
                                    id="innovateTextCircle"
                                    d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
                                />
                            </defs>
                            <text fontSize="8" fill="#ffffff" fontWeight="bold">
                                <textPath xlinkHref="#innovateTextCircle" startOffset="0%">
                                    INNOVATE • BUILD • SCALE • INNOVATE • BUILD • SCALE •
                                </textPath>
                            </text>
                            <circle
                                cx="50" cy="50" r="25"
                                fill="none"
                                stroke="#6464ad"
                                strokeWidth="1"
                                strokeDasharray="1,3"
                                className="animate-spin-slow"
                                style={{ animationDuration: '15s' }}
                            />
                        </svg>

                        {/* Center icon */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <FaRocket className="text-[#6464ad] text-xl" />
                        </div>
                    </motion.div>
                </div>

                {/* Floating elements to fill space */}
                <motion.div
                    className="absolute top-1/3 left-1/4 text-[#6464ad] z-10 flex items-center gap-2"
                    animate={{ y: [0, -15, 0] }}
                    transition={{ duration: 5, repeat: Infinity }}
                >
                    <div className="w-1 h-12 bg-gradient-to-b from-[#6464ad] to-transparent"></div>
                    <div className="text-white text-xs">
                        <div className="font-bold">Startups</div>
                        <div className="text-[#afadd5] text-[10px]">Showcase</div>
                    </div>
                </motion.div>

                <motion.div
                    className="absolute bottom-1/3 right-1/4 text-[#6464ad] z-10 flex items-center gap-2"
                    animate={{ y: [0, 15, 0] }}
                    transition={{ duration: 6, repeat: Infinity, delay: 0.5 }}
                >
                    <div className="text-white text-xs text-right">
                        <div className="font-bold">Pitch</div>
                        <div className="text-[#afadd5] text-[10px]">Your Idea</div>
                    </div>
                    <div className="w-1 h-12 bg-gradient-to-t from-[#6464ad] to-transparent"></div>
                </motion.div>

                {/* Diagonal line element */}
                <div className="absolute bottom-40 left-1/3 z-10">
                    <motion.div
                        className="h-px w-32 bg-[#6464ad]/50 origin-left"
                        style={{ transform: 'rotate(-45deg)' }}
                        animate={{ width: [0, 128, 128, 0], opacity: [0, 1, 1, 0] }}
                        transition={{ duration: 4, repeat: Infinity }}
                    ></motion.div>
                </div>

                {/* #StartupIndia circular text with improved border */}
                <motion.div
                    className="absolute top-14 right-14 w-32 h-32 rounded-full flex items-center justify-center z-20"
                    whileHover={{ scale: 1.1 }}
                >
                    <div className="relative w-full h-full">
                        {/* Multiple animated borders */}
                        <div className="absolute inset-0 rounded-full border border-[#6464ad]/30"></div>
                        <motion.div
                            className="absolute inset-2 rounded-full border border-[#afadd5]/20"
                            animate={{ scale: [1, 1.1, 1] }}
                            transition={{ duration: 3, repeat: Infinity }}
                        ></motion.div>
                        <motion.div
                            className="absolute inset-4 rounded-full border border-[#d9daee]/10"
                            animate={{ scale: [1, 0.9, 1] }}
                            transition={{ duration: 4, repeat: Infinity }}
                        ></motion.div>

                        {/* Animated dots around circle */}
                        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, index) => (
                            <motion.div
                                key={angle}
                                className="absolute w-2 h-2 rounded-full bg-[#6464ad]"
                                style={{
                                    top: `calc(50% + ${Math.sin(angle * Math.PI / 180) * 55}%)`,
                                    left: `calc(50% + ${Math.cos(angle * Math.PI / 180) * 55}%)`,
                                    transform: 'translate(-50%, -50%)'
                                }}
                                animate={{
                                    opacity: [0.3, 1, 0.3],
                                    scale: [0.8, 1.2, 0.8]
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    delay: index * 0.25
                                }}
                            />
                        ))}

                        <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" style={{ overflow: 'visible' }}>
                            <defs>
                                <path
                                    id="textCircle"
                                    d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
                                />
                            </defs>
                            <text fontSize="9" fill="#ffffff" fontWeight="bold">
                                <textPath xlinkHref="#textCircle" startOffset="0%">
                                    # StartupsIndia • # StartupsIndia • # StartupsIndia •
                                </textPath>
                            </text>
                            <circle
                                cx="50" cy="50" r="28"
                                fill="none"
                                stroke="#6464ad"
                                strokeWidth="1"
                                strokeDasharray="1,3"
                                className="animate-spin-slow"
                                style={{ animationDuration: '20s' }}
                            />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <FaRocket className="text-[#6464ad] text-xl" />
                        </div>
                    </div>
                </motion.div>

                {/* Light bulb element - top left */}
                <motion.div
                    className="absolute top-20 left-20 z-20 flex flex-col items-center"
                    animate={{ y: [0, -10, 0] }}
                    transition={{ duration: 3, repeat: Infinity }}
                >
                    <FaLightbulb className="text-[#6464ad] text-2xl" />
                </motion.div>

                {/* Sparkle Elements */}
                <motion.div
                    className="absolute top-1/3 right-1/4 text-[#6464ad] z-10"
                    animate={{
                        scale: [1, 1.2, 1],
                        rotate: [0, 15, 0]
                    }}
                    transition={{
                        repeat: Infinity,
                        duration: 2,
                        repeatType: "reverse"
                    }}
                >
                    <RiSparklingFill size={24} />
                </motion.div>

                {/* Main Content - Centered */}
                <div className="container mx-auto px-4 py-16 md:py-20 relative z-10 max-w-5xl">
                    <div className="flex flex-col items-center justify-center text-center">
                        {/* Date with Line */}
                        <motion.div
                            className="flex items-center justify-center"
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className="flex items-center gap-3">
                                <div className="h-[1px] w-10 md:w-16 bg-[#6464ad]"></div>
                                <p className="text-gray-300 text-base md:text-lg font-medium">End of May 2025</p>
                                <div className="h-[1px] w-10 md:w-16 bg-[#6464ad]"></div>
                            </div>
                        </motion.div>

                        {/* Business Events Heading with star element */}
                        <motion.div
                            className="mt-6 mb-4"
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            <h2 className="text-4xl md:text-6xl lg:text-7xl tracking-wide font-bold text-white">
                                <span className="inline-flex">
                                    <span className="text-[#6464ad]">B</span>usiness&nbsp;<span className="text-[#6464ad]">E</span>vents&nbsp;20<span className="text-[#6464ad]">25</span>
                                </span>
                            </h2>
                        </motion.div>

                        {/* RISEUP 2.0 */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className="mt-3"
                        >
                            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-widest">
                                RISEUP <span className="text-[#afadd5]">2.0</span>
                            </h1>
                        </motion.div>

                        {/* Mentorsity and X UNTIEUP */}
                        <motion.div
                            className="flex items-center justify-center gap-4 mt-6"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.6 }}
                        >
                            <motion.img
                                src={logoSrc}
                                alt="Mentorsity"
                                className="h-10 md:h-12 object-contain"
                                whileHover={{ scale: 1.05 }}
                                transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                onError={handleImageError}
                            />

                            <div className="text-[#6464ad] text-xl md:text-2xl font-bold">X</div>

                            <div className="text-white text-2xl md:text-3xl font-bold">UNTIEUP</div>
                        </motion.div>

                        {/* Description */}
                        <motion.p
                            className="text-gray-300 max-w-2xl mx-auto mt-6 text-base md:text-lg"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.8 }}
                        >
                            Join us for a transformative business summit that brings together entrepreneurs, investors, and industry leaders to innovate, connect, and grow.
                        </motion.p>

                        {/* Location and Register together - centered */}
                        <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-6 mt-8">
                            {/* Location */}
                            <motion.div
                                className="flex items-center justify-center"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 1.0 }}
                            >
                                <div className="flex items-center bg-white/5 px-5 py-3">
                                    <motion.div
                                        className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 bg-[#6464ad]/20 mr-3 text-[#afadd5]"
                                        whileHover={{ scale: 1.1 }}
                                    >
                                        <IoLocationOutline className="w-5 h-5" />
                                    </motion.div>
                                    <span className="text-white text-sm md:text-base font-medium">Galgotias University, Noida</span>
                                </div>
                            </motion.div>

                            {/* Register Button - square corners */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.7, delay: 1.2 }}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={handleRegisterClick}
                            >
                                <motion.button
                                    className="bg-gradient-to-r from-[#6464ad] to-[#afadd5] py-3 px-8 md:px-10 flex items-center justify-center gap-3 shadow-lg cursor-pointer"
                                    animate={isRegistering ? { scale: [1, 1.1, 1] } : {}}
                                    transition={{ duration: 0.5 }}
                                >
                                    <span className="text-white font-bold text-base md:text-lg">Register Now</span>
                                    <motion.div
                                        whileHover={{ x: 3 }}
                                        transition={{ type: "spring", stiffness: 400 }}
                                    >
                                        <HiOutlineArrowNarrowRight className="w-5 h-5 text-white" />
                                    </motion.div>
                                </motion.button>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Our Vision Section */}
            <div className="w-full bg-gradient-to-b from-black to-[#1a1a1a] py-12 md:py-16 relative overflow-hidden">
                {/* Background decorative elements */}
                <div className="absolute inset-0 z-0 overflow-hidden">
                    <div className="absolute top-20 left-20 w-32 h-32 rounded-full border-2 border-[#6464ad]/30"></div>
                    <div className="absolute bottom-20 right-20 w-24 h-24 rounded-full bg-[#6464ad]/10"></div>
                    <div className="absolute top-1/2 right-1/4 w-16 h-16 bg-[#6464ad] rounded-full opacity-10"></div>

                    {/* Grid pattern */}
                    <div className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(#ffffff10 1px, transparent 1px)`,
                            backgroundSize: '30px 30px'
                        }}>
                    </div>
                </div>

                <div className="container mx-auto px-4 relative z-10">
                    <div className="flex flex-col md:flex-row items-center justify-center max-w-6xl mx-auto gap-8 md:gap-12">
                        {/* Left side image with enhanced styling */}
                        <motion.div
                            className="w-full md:w-1/2 flex justify-center relative"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.7 }}
                        >
                            <div className="relative">
                                {/* Background decorative elements */}
                                <div className="absolute w-32 h-32 bg-[#6464ad] rounded-full -z-10 -top-4 -left-4 opacity-30"></div>
                                <div className="absolute w-24 h-24 bg-[#afadd5] rounded-full -z-10 bottom-4 -right-4 opacity-40"></div>

                                {/* Rotating border */}
                                <motion.div
                                    className="absolute inset-0 border-2 border-[#6464ad]/50 rounded-lg"
                                    animate={{ rotate: 360 }}
                                    transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                                />

                                <motion.img
                                    src={visionImg}
                                    alt="Our Vision"
                                    className="w-4/5 md:w-11/12 max-w-md object-contain relative z-10 rounded-lg"
                                    whileHover={{ scale: 1.03 }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                />

                                {/* Sparkle elements */}
                                <motion.div
                                    className="absolute top-1/4 right-0 text-[#6464ad]"
                                    animate={{
                                        scale: [1, 1.4, 1],
                                        opacity: [0.7, 1, 0.7]
                                    }}
                                    transition={{
                                        duration: 2,
                                        repeat: Infinity,
                                        repeatType: "reverse"
                                    }}
                                >
                                    <RiSparklingFill size={24} />
                                </motion.div>

                                <motion.div
                                    className="absolute bottom-1/4 left-0 text-[#afadd5]"
                                    animate={{
                                        scale: [1, 1.4, 1],
                                        opacity: [0.7, 1, 0.7]
                                    }}
                                    transition={{
                                        duration: 2.5,
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                        delay: 0.5
                                    }}
                                >
                                    <RiSparklingFill size={20} />
                                </motion.div>
                            </div>
                        </motion.div>

                        {/* Right side content */}
                        <motion.div
                            className="w-full md:w-1/2 flex flex-col items-start"
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.7, delay: 0.2 }}
                        >
                            {/* Section title with decorative element */}
                            <div className="relative mb-6">
                                <div className="h-[1px] w-16 bg-[#6464ad] absolute top-1/2 -left-20 hidden md:block"></div>
                                <h2 className="text-3xl md:text-4xl font-bold text-white">Our <span className="text-[#6464ad]">Vision</span></h2>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#6464ad] to-[#afadd5] mt-2"></div>
                            </div>

                            {/* Vision text */}
                            <motion.p
                                className="text-base md:text-lg text-gray-300 mt-4 leading-relaxed"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.4 }}
                            >
                                To create a power-packed youth summit that merges entrepreneurship, creativity, career, and culture — inspiring the next generation to <span className="text-[#afadd5] font-semibold">RiseUp</span> with purpose and passion.
                            </motion.p>

                            {/* Vision points */}
                            <div className="mt-6 space-y-4">
                                <motion.div
                                    className="flex items-center gap-3"
                                    initial={{ opacity: 0, x: -10 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, delay: 0.6 }}
                                >
                                    <div className="w-8 h-8 bg-[#6464ad]/20 flex items-center justify-center text-[#afadd5]">
                                        <FaLightbulb className="w-4 h-4" />
                                    </div>
                                    <p className="text-gray-300">Fostering innovation and entrepreneurship</p>
                                </motion.div>

                                <motion.div
                                    className="flex items-center gap-3"
                                    initial={{ opacity: 0, x: -10 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, delay: 0.8 }}
                                >
                                    <div className="w-8 h-8 bg-[#6464ad]/20 flex items-center justify-center text-[#afadd5]">
                                        <FaNetworkWired className="w-4 h-4" />
                                    </div>
                                    <p className="text-gray-300">Creating valuable networking opportunities</p>
                                </motion.div>

                                <motion.div
                                    className="flex items-center gap-3"
                                    initial={{ opacity: 0, x: -10 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, delay: 1.0 }}
                                >
                                    <div className="w-8 h-8 bg-[#6464ad]/20 flex items-center justify-center text-[#afadd5]">
                                        <FaRocket className="w-4 h-4" />
                                    </div>
                                    <p className="text-gray-300">Accelerating growth for startups and businesses</p>
                                </motion.div>
                            </div>

                            {/* Decorative element */}
                            <motion.div
                                className="w-12 h-12 bg-[#afadd5] rounded-full absolute bottom-4 right-8 -z-10 opacity-20 md:block hidden"
                                animate={{
                                    scale: [1, 1.2, 1],
                                }}
                                transition={{
                                    duration: 4,
                                    repeat: Infinity,
                                    repeatType: "reverse"
                                }}
                            />
                        </motion.div>
                    </div>
                </div>
            </div>

            {/* About the Event Section - Redesigned with better alignment and elements */}
            <div className="w-full bg-gradient-to-b from-black to-[#1a1a1a] py-14 md:py-20 relative overflow-hidden">
                {/* Background decorative elements */}
                <div className="absolute inset-0 z-0 overflow-hidden">
                    {/* Grid pattern */}
                    <div className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(#ffffff08 1px, transparent 1px)`,
                            backgroundSize: '30px 30px'
                        }}>
                    </div>

                    {/* Left side decoration - line elements */}
                    <div className="absolute left-0 top-0 h-full w-24 pointer-events-none">
                        <motion.div
                            className="absolute left-12 top-1/4 w-1 h-24 bg-gradient-to-b from-[#6464ad] to-transparent"
                            animate={{
                                height: [60, 100, 60],
                                opacity: [0.3, 0.7, 0.3]
                            }}
                            transition={{ duration: 6, repeat: Infinity }}
                        />
                        <motion.div
                            className="absolute left-6 top-1/2 w-1 h-16 bg-gradient-to-b from-[#afadd5] to-transparent"
                            animate={{
                                height: [40, 80, 40],
                                opacity: [0.2, 0.5, 0.2]
                            }}
                            transition={{ duration: 4, repeat: Infinity, delay: 1 }}
                        />
                        <motion.div
                            className="absolute left-18 bottom-1/4 w-1 h-20 bg-gradient-to-b from-[#d9daee] to-transparent"
                            animate={{
                                height: [50, 90, 50],
                                opacity: [0.1, 0.4, 0.1]
                            }}
                            transition={{ duration: 5, repeat: Infinity, delay: 2 }}
                        />
                    </div>

                    {/* Right side decoration */}
                    <div className="absolute right-0 top-0 h-full w-24 pointer-events-none">
                        <motion.div
                            className="absolute right-6 top-1/3 w-px h-40 bg-gradient-to-b from-transparent via-[#6464ad] to-transparent"
                            animate={{
                                opacity: [0.2, 0.6, 0.2]
                            }}
                            transition={{ duration: 5, repeat: Infinity }}
                        />
                        <motion.div
                            className="absolute right-12 top-2/3 w-px h-32 bg-gradient-to-b from-transparent via-[#afadd5] to-transparent"
                            animate={{
                                opacity: [0.1, 0.5, 0.1]
                            }}
                            transition={{ duration: 4, repeat: Infinity, delay: 1.5 }}
                        />
                        <motion.div
                            className="absolute right-18 top-20 w-px h-24 bg-gradient-to-b from-transparent via-[#d9daee] to-transparent"
                            animate={{
                                opacity: [0.1, 0.3, 0.1]
                            }}
                            transition={{ duration: 3, repeat: Infinity, delay: 0.5 }}
                        />
                    </div>

                    {/* Diagonal elements */}
                    <div className="absolute left-1/4 bottom-20">
                        <motion.div
                            className="w-32 h-px bg-[#6464ad]/30 origin-left"
                            style={{ transform: 'rotate(-45deg)' }}
                            animate={{ width: [0, 128, 128, 0], opacity: [0, 0.6, 0.6, 0] }}
                            transition={{ duration: 6, repeat: Infinity }}
                        />
                    </div>
                    <div className="absolute right-1/4 top-40">
                        <motion.div
                            className="w-32 h-px bg-[#6464ad]/30 origin-right"
                            style={{ transform: 'rotate(45deg)' }}
                            animate={{ width: [0, 128, 128, 0], opacity: [0, 0.6, 0.6, 0] }}
                            transition={{ duration: 6, repeat: Infinity, delay: 2 }}
                        />
                    </div>
                </div>

                {/* Floating accent elements */}
                <motion.div
                    className="absolute left-16 top-1/4 flex items-center gap-2 z-10"
                    animate={{ y: [0, -20, 0] }}
                    transition={{ duration: 6, repeat: Infinity }}
                >
                    <div className="w-1 h-16 bg-gradient-to-b from-[#6464ad] to-transparent"></div>
                    <div className="text-white text-xs">
                        <div className="font-bold text-[#afadd5]">EXPLORE</div>
                        <div className="text-[#d9daee] text-[10px]">Opportunities</div>
                    </div>
                </motion.div>

                <motion.div
                    className="absolute right-16 bottom-1/4 flex items-center gap-2 z-10"
                    animate={{ y: [0, 20, 0] }}
                    transition={{ duration: 7, repeat: Infinity, delay: 1 }}
                >
                    <div className="text-white text-xs text-right">
                        <div className="font-bold text-[#afadd5]">CONNECT</div>
                        <div className="text-[#d9daee] text-[10px]">Network</div>
                    </div>
                    <div className="w-1 h-16 bg-gradient-to-t from-[#6464ad] to-transparent"></div>
                </motion.div>

                <div className="container mx-auto px-4 relative z-10">
                    <motion.div
                        className="text-center mb-12"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                    >
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">About the <span className="text-[#6464ad]">Event</span></h2>
                        <div className="h-1 w-24 bg-gradient-to-r from-[#6464ad] to-[#afadd5] mx-auto"></div>
                        <p className="max-w-2xl mx-auto text-gray-300 mt-4">Join us for an unforgettable experience with industry leaders, innovative startups, and networking opportunities</p>
                    </motion.div>

                    <div className="max-w-6xl mx-auto">
                        {/* First Row */}
                        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mb-10 md:mb-12">
                            {/* VC Funds */}
                            <motion.div
                                className="w-[calc(33%-24px)] min-w-[180px] max-w-[250px] bg-gradient-to-br from-[#ffffff08] to-[#ffffff03] backdrop-blur-sm rounded-lg p-8 flex flex-col items-center transform transition-all duration-300 border border-[#ffffff10]"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.1 }}
                                whileHover={{
                                    y: -8,
                                    boxShadow: "0 15px 30px rgba(100, 100, 173, 0.15)"
                                }}
                            >
                                <div className="w-16 h-16 bg-gradient-to-br from-[#6464ad]/20 to-[#d9daee]/10 rounded-lg flex items-center justify-center mb-5 transform transition-transform duration-500 border border-[#ffffff10]">
                                    <FaHandshake className="text-[#afadd5] text-2xl" />
                                </div>
                                <h3 className="text-2xl font-bold text-white text-center">12+</h3>
                                <p className="text-gray-300 text-sm text-center mt-2 font-medium">VC Funds</p>

                                {/* Animated indicator */}
                                <motion.div
                                    className="w-8 h-1 bg-[#6464ad] mt-4 rounded-full"
                                    animate={{ width: ["32px", "16px", "32px"] }}
                                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
                                />
                            </motion.div>

                            {/* Attendees */}
                            <motion.div
                                className="w-[calc(33%-24px)] min-w-[180px] max-w-[250px] bg-gradient-to-br from-[#ffffff08] to-[#ffffff03] backdrop-blur-sm rounded-lg p-8 flex flex-col items-center transform transition-all duration-300 border border-[#ffffff10]"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                                whileHover={{
                                    y: -8,
                                    boxShadow: "0 15px 30px rgba(100, 100, 173, 0.15)"
                                }}
                            >
                                <div className="w-16 h-16 bg-gradient-to-br from-[#6464ad]/20 to-[#d9daee]/10 rounded-lg flex items-center justify-center mb-5 transform transition-transform duration-500 border border-[#ffffff10]">
                                    <FaUsers className="text-[#afadd5] text-2xl" />
                                </div>
                                <h3 className="text-2xl font-bold text-white text-center">4000+</h3>
                                <p className="text-gray-300 text-sm text-center mt-2 font-medium">Attendees</p>

                                {/* Animated indicator */}
                                <motion.div
                                    className="w-8 h-1 bg-[#6464ad] mt-4 rounded-full"
                                    animate={{ width: ["32px", "16px", "32px"] }}
                                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse", delay: 0.3 }}
                                />
                            </motion.div>

                            {/* Media Publishers */}
                            <motion.div
                                className="w-[calc(33%-24px)] min-w-[180px] max-w-[250px] bg-gradient-to-br from-[#ffffff08] to-[#ffffff03] backdrop-blur-sm rounded-lg p-8 flex flex-col items-center transform transition-all duration-300 border border-[#ffffff10]"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.3 }}
                                whileHover={{
                                    y: -8,
                                    boxShadow: "0 15px 30px rgba(100, 100, 173, 0.15)"
                                }}
                            >
                                <div className="w-16 h-16 bg-gradient-to-br from-[#6464ad]/20 to-[#d9daee]/10 rounded-lg flex items-center justify-center mb-5 transform transition-transform duration-500 border border-[#ffffff10]">
                                    <FaMicrophone className="text-[#afadd5] text-2xl" />
                                </div>
                                <h3 className="text-2xl font-bold text-white text-center">10+</h3>
                                <p className="text-gray-300 text-sm text-center mt-2 font-medium">Media Publishers</p>

                                {/* Animated indicator */}
                                <motion.div
                                    className="w-8 h-1 bg-[#6464ad] mt-4 rounded-full"
                                    animate={{ width: ["32px", "16px", "32px"] }}
                                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse", delay: 0.6 }}
                                />
                            </motion.div>
                        </div>

                        {/* Second Row */}
                        <div className="flex flex-wrap justify-center gap-6 md:gap-10">
                            {/* Startups */}
                            <motion.div
                                className="w-[calc(33%-24px)] min-w-[180px] max-w-[250px] bg-gradient-to-br from-[#ffffff08] to-[#ffffff03] backdrop-blur-sm rounded-lg p-8 flex flex-col items-center transform transition-all duration-300 border border-[#ffffff10]"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.4 }}
                                whileHover={{
                                    y: -8,
                                    boxShadow: "0 15px 30px rgba(100, 100, 173, 0.15)"
                                }}
                            >
                                <div className="w-16 h-16 bg-gradient-to-br from-[#6464ad]/20 to-[#d9daee]/10 rounded-lg flex items-center justify-center mb-5 transform transition-transform duration-500 border border-[#ffffff10]">
                                    <RiSparklingFill className="text-[#afadd5] text-2xl" />
                                </div>
                                <h3 className="text-2xl font-bold text-white text-center">50+</h3>
                                <p className="text-gray-300 text-sm text-center mt-2 font-medium">Startups</p>

                                {/* Animated indicator */}
                                <motion.div
                                    className="w-8 h-1 bg-[#6464ad] mt-4 rounded-full"
                                    animate={{ width: ["32px", "16px", "32px"] }}
                                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse", delay: 0.9 }}
                                />
                            </motion.div>

                            {/* Stalls */}
                            <motion.div
                                className="w-[calc(33%-24px)] min-w-[180px] max-w-[250px] bg-gradient-to-br from-[#ffffff08] to-[#ffffff03] backdrop-blur-sm rounded-lg p-8 flex flex-col items-center transform transition-all duration-300 border border-[#ffffff10]"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.5 }}
                                whileHover={{
                                    y: -8,
                                    boxShadow: "0 15px 30px rgba(100, 100, 173, 0.15)"
                                }}
                            >
                                <div className="w-16 h-16 bg-gradient-to-br from-[#6464ad]/20 to-[#d9daee]/10 rounded-lg flex items-center justify-center mb-5 transform transition-transform duration-500 border border-[#ffffff10]">
                                    <FaBuilding className="text-[#afadd5] text-2xl" />
                                </div>
                                <h3 className="text-2xl font-bold text-white text-center">10+</h3>
                                <p className="text-gray-300 text-sm text-center mt-2 font-medium">Stalls</p>

                                {/* Animated indicator */}
                                <motion.div
                                    className="w-8 h-1 bg-[#6464ad] mt-4 rounded-full"
                                    animate={{ width: ["32px", "16px", "32px"] }}
                                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse", delay: 1.2 }}
                                />
                            </motion.div>

                            {/* Social Media */}
                            <motion.div
                                className="w-[calc(33%-24px)] min-w-[180px] max-w-[250px] bg-gradient-to-br from-[#ffffff08] to-[#ffffff03] backdrop-blur-sm rounded-lg p-8 flex flex-col items-center transform transition-all duration-300 border border-[#ffffff10]"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.6 }}
                                whileHover={{
                                    y: -8,
                                    boxShadow: "0 15px 30px rgba(100, 100, 173, 0.15)"
                                }}
                            >
                                <div className="w-16 h-16 bg-gradient-to-br from-[#6464ad]/20 to-[#d9daee]/10 rounded-lg flex items-center justify-center mb-5 transform transition-transform duration-500 border border-[#ffffff10]">
                                    <IoIosGlobe className="text-[#afadd5] text-2xl" />
                                </div>
                                <h3 className="text-2xl font-bold text-white text-center">5 lakh +</h3>
                                <p className="text-gray-300 text-sm text-center mt-2 font-medium">Social media shoutouts</p>

                                {/* Animated indicator */}
                                <motion.div
                                    className="w-8 h-1 bg-[#6464ad] mt-4 rounded-full"
                                    animate={{ width: ["32px", "16px", "32px"] }}
                                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse", delay: 1.5 }}
                                />
                            </motion.div>
                        </div>
                    </div>

                    {/* Bottom decoration */}
                    <div className="mt-16 flex justify-center">
                        <motion.div
                            className="h-px w-40 bg-gradient-to-r from-transparent via-[#6464ad] to-transparent"
                            animate={{ opacity: [0.3, 0.7, 0.3] }}
                            transition={{ duration: 3, repeat: Infinity }}
                        />
                    </div>
                </div>
            </div>

            {/* Journey Through Numbers Section */}
            <div className="w-full bg-gradient-to-b from-black to-[#1a1a1a] py-14 md:py-20 relative overflow-hidden">
                {/* Background decorative elements */}
                <div className="absolute inset-0 z-0 overflow-hidden">
                    <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-[#6464ad]/10 -translate-x-1/3 -translate-y-1/3"></div>
                    <div className="absolute bottom-0 right-0 w-64 h-64 rounded-full bg-[#6464ad]/5 translate-x-1/3 translate-y-1/3"></div>

                    {/* Animated glowing dots */}
                    <motion.div
                        className="absolute top-1/4 right-1/4 w-3 h-3 rounded-full bg-[#afadd5]"
                        animate={{
                            opacity: [0.2, 0.8, 0.2],
                            scale: [1, 1.3, 1]
                        }}
                        transition={{ duration: 3, repeat: Infinity }}
                    />

                    <motion.div
                        className="absolute bottom-1/3 left-1/4 w-2 h-2 rounded-full bg-[#6464ad]"
                        animate={{
                            opacity: [0.2, 0.7, 0.2],
                            scale: [1, 1.2, 1]
                        }}
                        transition={{ duration: 2.5, repeat: Infinity, delay: 0.5 }}
                    />

                    <motion.div
                        className="absolute top-2/3 right-1/3 w-4 h-4 rounded-full bg-[#d9daee]/30"
                        animate={{
                            opacity: [0.1, 0.5, 0.1],
                            scale: [1, 1.4, 1]
                        }}
                        transition={{ duration: 4, repeat: Infinity, delay: 1 }}
                    />

                    {/* Grid pattern */}
                    <div className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(#ffffff10 1px, transparent 1px)`,
                            backgroundSize: '30px 30px'
                        }}>
                    </div>
                </div>

                <div className="container mx-auto px-4 relative z-10">
                    <motion.div
                        className="text-center mb-12"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                    >
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">Journey Through <span className="text-[#6464ad]">Numbers</span></h2>
                        <div className="h-1 w-24 bg-gradient-to-r from-[#6464ad] to-[#afadd5] mx-auto"></div>
                        <p className="max-w-2xl mx-auto text-gray-300 mt-4">Our impact is measured through meaningful connections and growing numbers</p>
                    </motion.div>

                    <div className="flex flex-wrap justify-center items-center max-w-5xl mx-auto">
                        {/* Mentors */}
                        <motion.div
                            className="flex-1 flex flex-col items-center py-6 min-w-[180px] relative group"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            whileHover={{ y: -5 }}
                        >
                            <div className="absolute inset-0 bg-[#6464ad]/5 scale-0 group-hover:scale-100 transition-transform duration-300 rounded-xl"></div>
                            <div className="relative">
                                <div className="pt-3 border-t-4 border-[#6464ad]">
                                    <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-white inline-block pb-1">290<span className="text-[#6464ad]">+</span></div>
                                </div>
                                <p className="text-lg md:text-xl text-gray-300 font-medium mt-2">Mentors</p>

                                {/* Animated underline */}
                                <motion.div
                                    className="h-px w-12 bg-[#6464ad] mx-auto mt-3"
                                    animate={{ width: ['48px', '80px', '48px'] }}
                                    transition={{ duration: 2, repeat: Infinity }}
                                />
                            </div>
                        </motion.div>

                        {/* Mentees */}
                        <motion.div
                            className="flex-1 flex flex-col items-center py-6 min-w-[180px] relative group"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            whileHover={{ y: -5 }}
                        >
                            <div className="absolute inset-0 bg-[#6464ad]/5 scale-0 group-hover:scale-100 transition-transform duration-300 rounded-xl"></div>
                            <div className="relative">
                                <div className="pt-3 border-t-4 border-[#afadd5]">
                                    <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-white inline-block pb-1">8,000<span className="text-[#afadd5]">+</span></div>
                                </div>
                                <p className="text-lg md:text-xl text-gray-300 font-medium mt-2">Mentees</p>

                                {/* Animated underline */}
                                <motion.div
                                    className="h-px w-12 bg-[#afadd5] mx-auto mt-3"
                                    animate={{ width: ['48px', '80px', '48px'] }}
                                    transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
                                />
                            </div>
                        </motion.div>

                        {/* Users Affected */}
                        <motion.div
                            className="flex-1 flex flex-col items-center py-6 min-w-[180px] relative group"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                            whileHover={{ y: -5 }}
                        >
                            <div className="absolute inset-0 bg-[#6464ad]/5 scale-0 group-hover:scale-100 transition-transform duration-300 rounded-xl"></div>
                            <div className="relative">
                                <div className="pt-3 border-t-4 border-[#d9daee]">
                                    <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-white inline-block pb-1">27,000<span className="text-[#d9daee]">+</span></div>
                                </div>
                                <p className="text-lg md:text-xl text-gray-300 font-medium mt-2">Users Affected</p>

                                {/* Animated underline */}
                                <motion.div
                                    className="h-px w-12 bg-[#d9daee] mx-auto mt-3"
                                    animate={{ width: ['48px', '80px', '48px'] }}
                                    transition={{ duration: 2, repeat: Infinity, delay: 1 }}
                                />
                            </div>
                        </motion.div>

                        {/* Mentoring */}
                        <motion.div
                            className="flex-1 flex flex-col items-center py-6 min-w-[180px] relative group"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.6 }}
                            whileHover={{ y: -5 }}
                        >
                            <div className="absolute inset-0 bg-[#6464ad]/5 scale-0 group-hover:scale-100 transition-transform duration-300 rounded-xl"></div>
                            <div className="relative">
                                <div className="pt-3 border-t-4 border-[#6464ad]">
                                    <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-white inline-block pb-1">2,700<span className="text-[#6464ad]">+</span></div>
                                </div>
                                <p className="text-lg md:text-xl text-gray-300 font-medium mt-2">Mentoring</p>

                                {/* Animated underline */}
                                <motion.div
                                    className="h-px w-12 bg-[#6464ad] mx-auto mt-3"
                                    animate={{ width: ['48px', '80px', '48px'] }}
                                    transition={{ duration: 2, repeat: Infinity, delay: 1.5 }}
                                />
                            </div>
                        </motion.div>
                    </div>

                    {/* Decorative line at the bottom */}
                    <div className="max-w-md mx-auto mt-12">
                        <motion.div
                            className="h-px w-full bg-gradient-to-r from-transparent via-[#6464ad] to-transparent"
                            animate={{ opacity: [0.3, 0.7, 0.3] }}
                            transition={{ duration: 3, repeat: Infinity }}
                        />
                    </div>
                </div>
            </div>

            {/* Our Speakers Section */}
            <div className="w-full bg-gradient-to-b from-black to-[#1a1a1a] py-14 md:py-20 relative overflow-hidden">
                {/* Background decorative elements */}
                <div className="absolute inset-0 z-0 overflow-hidden">
                    <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#6464ad]/5 translate-x-1/3 -translate-y-1/3"></div>
                    <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-[#6464ad]/10 -translate-x-1/3 translate-y-1/3"></div>

                    {/* Animated glowing dots */}
                    <motion.div
                        className="absolute top-1/3 left-1/4 w-3 h-3 rounded-full bg-[#afadd5]"
                        animate={{
                            opacity: [0.2, 0.8, 0.2],
                            scale: [1, 1.3, 1]
                        }}
                        transition={{ duration: 3, repeat: Infinity, delay: 0.2 }}
                    />

                    <motion.div
                        className="absolute bottom-1/4 right-1/3 w-2 h-2 rounded-full bg-[#6464ad]"
                        animate={{
                            opacity: [0.2, 0.7, 0.2],
                            scale: [1, 1.2, 1]
                        }}
                        transition={{ duration: 2.5, repeat: Infinity, delay: 0.7 }}
                    />

                    {/* Grid pattern */}
                    <div className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(#ffffff10 1px, transparent 1px)`,
                            backgroundSize: '30px 30px'
                        }}>
                    </div>
                </div>

                <div className="container mx-auto px-4 relative z-10">
                    <motion.div
                        className="text-center mb-12"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                    >
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">Our <span className="text-[#6464ad]">Speakers</span></h2>
                        <div className="h-1 w-24 bg-gradient-to-r from-[#6464ad] to-[#afadd5] mx-auto"></div>
                        <p className="max-w-2xl mx-auto text-gray-300 mt-4">Visionary leaders sharing insights on innovation and business growth</p>
                    </motion.div>

                    <div className="flex flex-row flex-wrap md:flex-nowrap justify-center max-w-6xl mx-auto gap-6 md:gap-8">
                        {/* Speaker 1 */}
                        <motion.div
                            className="w-full sm:w-[45%] md:w-1/4 h-[350px] relative overflow-hidden group cursor-pointer rounded-lg shadow-xl"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                            whileHover={{
                                y: -10,
                                boxShadow: "0 20px 30px rgba(100, 100, 173, 0.3)"
                            }}
                        >
                            {/* Border animation */}
                            <motion.div
                                className="absolute inset-0 border-2 border-[#6464ad]/50 rounded-lg z-20 pointer-events-none opacity-0 group-hover:opacity-100"
                                animate={{ scale: [1, 1.05, 1] }}
                                transition={{ duration: 2, repeat: Infinity }}
                            ></motion.div>

                            <img
                                src={riyaImg}
                                alt="Riya Gadhwal"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            {/* Dark gradient overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80"></div>

                            {/* Hover gradient overlay */}
                            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-300"
                                style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(100, 100, 173, 0.5) 100%)' }}>
                            </div>

                            {/* Text content */}
                            <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300 group-hover:translate-y-0">
                                <h3 className="text-2xl font-bold text-white mb-1">Riya Gadhwal</h3>
                                <p className="text-[#afadd5] text-sm mb-3">Entrepreneur & Innovator</p>
                            </div>

                            {/* Decorative corner accent */}
                            <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden">
                                <div className="absolute transform rotate-45 bg-[#6464ad] text-white text-xs font-bold py-1 right-[-35px] top-[20px] w-[120px] text-center">
                                    FEATURED
                                </div>
                            </div>
                        </motion.div>

                        {/* Speaker 2 */}
                        <motion.div
                            className="w-full sm:w-[45%] md:w-1/4 h-[350px] relative overflow-hidden group cursor-pointer rounded-lg shadow-xl"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            whileHover={{
                                y: -10,
                                boxShadow: "0 20px 30px rgba(100, 100, 173, 0.3)"
                            }}
                        >
                            {/* Border animation */}
                            <motion.div
                                className="absolute inset-0 border-2 border-[#6464ad]/50 rounded-lg z-20 pointer-events-none opacity-0 group-hover:opacity-100"
                                animate={{ scale: [1, 1.05, 1] }}
                                transition={{ duration: 2, repeat: Infinity }}
                            ></motion.div>

                            <img
                                src={anujImg}
                                alt="Anuj Nevetia"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            {/* Dark gradient overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80"></div>

                            {/* Hover gradient overlay */}
                            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-300"
                                style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(100, 100, 173, 0.5) 100%)' }}>
                            </div>

                            {/* Text content */}
                            <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300 group-hover:translate-y-0">
                                <h3 className="text-2xl font-bold text-white mb-1">Anuj Nevetia</h3>
                                <p className="text-[#afadd5] text-sm mb-3">Business Strategist</p>
                            </div>
                        </motion.div>

                        {/* Speaker 3 */}
                        <motion.div
                            className="w-full sm:w-[45%] md:w-1/4 h-[350px] relative overflow-hidden group cursor-pointer rounded-lg shadow-xl"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.3 }}
                            whileHover={{
                                y: -10,
                                boxShadow: "0 20px 30px rgba(100, 100, 173, 0.3)"
                            }}
                        >
                            {/* Border animation */}
                            <motion.div
                                className="absolute inset-0 border-2 border-[#6464ad]/50 rounded-lg z-20 pointer-events-none opacity-0 group-hover:opacity-100"
                                animate={{ scale: [1, 1.05, 1] }}
                                transition={{ duration: 2, repeat: Infinity }}
                            ></motion.div>

                            <img
                                src={gauravImg}
                                alt="Gaurav Ghai"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            {/* Dark gradient overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80"></div>

                            {/* Hover gradient overlay */}
                            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-300"
                                style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(100, 100, 173, 0.5) 100%)' }}>
                            </div>

                            {/* Text content */}
                            <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300 group-hover:translate-y-0">
                                <h3 className="text-2xl font-bold text-white mb-1">Gaurav Ghai</h3>
                                <p className="text-[#afadd5] text-sm mb-3">Tech Visionary</p>
                            </div>
                        </motion.div>

                        {/* Speaker 4 */}
                        <motion.div
                            className="w-full sm:w-[45%] md:w-1/4 h-[350px] relative overflow-hidden group cursor-pointer rounded-lg shadow-xl"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                            whileHover={{
                                y: -10,
                                boxShadow: "0 20px 30px rgba(100, 100, 173, 0.3)"
                            }}
                        >
                            {/* Border animation */}
                            <motion.div
                                className="absolute inset-0 border-2 border-[#6464ad]/50 rounded-lg z-20 pointer-events-none opacity-0 group-hover:opacity-100"
                                animate={{ scale: [1, 1.05, 1] }}
                                transition={{ duration: 2, repeat: Infinity }}
                            ></motion.div>

                            <img
                                src={khalidImg}
                                alt="Khalid Wani"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            {/* Dark gradient overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80"></div>

                            {/* Hover gradient overlay */}
                            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-300"
                                style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(100, 100, 173, 0.5) 100%)' }}>
                            </div>

                            {/* Text content */}
                            <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300 group-hover:translate-y-0">
                                <h3 className="text-2xl font-bold text-white mb-1">Khalid Wani</h3>
                                <p className="text-[#afadd5] text-sm mb-3">Leadership Coach</p>
                            </div>
                        </motion.div>
                    </div>

                    {/* Central decorative element */}
                    <div className="flex justify-center mt-16">
                        <motion.div
                            className="flex items-center gap-3"
                            animate={{ opacity: [0.7, 1, 0.7] }}
                            transition={{ duration: 3, repeat: Infinity }}
                        >
                            <div className="w-8 h-px bg-[#6464ad]"></div>
                            <div className="text-[#afadd5] text-sm font-medium">More speakers to be announced</div>
                            <div className="w-8 h-px bg-[#6464ad]"></div>
                        </motion.div>
                    </div>
                </div>
            </div>

            {/* Call to Action for College Section */}
            <div className="w-full bg-gradient-to-b from-black to-[#1a1a1a] py-14 md:py-20 relative overflow-hidden">
                {/* Background decorative elements */}
                <div className="absolute inset-0 z-0 overflow-hidden">
                    <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-[#6464ad]/10 translate-x-1/3 -translate-y-1/3"></div>
                    <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-[#6464ad]/5 -translate-x-1/3 translate-y-1/3"></div>

                    {/* Animated glowing dots */}
                    <motion.div
                        className="absolute top-1/4 right-1/3 w-3 h-3 rounded-full bg-[#afadd5]"
                        animate={{
                            opacity: [0.2, 0.6, 0.2],
                            scale: [1, 1.3, 1]
                        }}
                        transition={{ duration: 3, repeat: Infinity, delay: 0.5 }}
                    />

                    <motion.div
                        className="absolute bottom-1/3 left-1/4 w-2 h-2 rounded-full bg-[#6464ad]"
                        animate={{
                            opacity: [0.2, 0.7, 0.2],
                            scale: [1, 1.2, 1]
                        }}
                        transition={{ duration: 2.5, repeat: Infinity, delay: 1 }}
                    />

                    {/* Diagonal lines */}
                    <motion.div
                        className="absolute top-0 right-1/4 h-px w-64 bg-[#6464ad]/30 origin-left"
                        style={{ transform: 'rotate(45deg) translateY(100px)' }}
                        animate={{ width: [0, 256, 256, 0], opacity: [0, 0.3, 0.3, 0] }}
                        transition={{ duration: 8, repeat: Infinity }}
                    ></motion.div>

                    <motion.div
                        className="absolute bottom-0 left-1/4 h-px w-64 bg-[#6464ad]/30 origin-left"
                        style={{ transform: 'rotate(-45deg) translateY(-100px)' }}
                        animate={{ width: [0, 256, 256, 0], opacity: [0, 0.3, 0.3, 0] }}
                        transition={{ duration: 8, repeat: Infinity, delay: 2 }}
                    ></motion.div>

                    {/* Grid pattern */}
                    <div className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(#ffffff10 1px, transparent 1px)`,
                            backgroundSize: '30px 30px'
                        }}>
                    </div>
                </div>

                <div className="container mx-auto px-4 relative z-10">
                    <div className="max-w-5xl mx-auto">
                        <div className="text-center mb-10">
                            <motion.h2
                                className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3"
                                initial={{ opacity: 0, y: -20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                                viewport={{ once: true }}
                            >
                                Call to Action for <span className="text-[#6464ad]">College</span>
                            </motion.h2>
                            <motion.div
                                className="h-1 w-24 bg-gradient-to-r from-[#6464ad] to-[#afadd5] mx-auto"
                                initial={{ width: 0 }}
                                whileInView={{ width: 96 }}
                                transition={{ duration: 0.8, delay: 0.3 }}
                                viewport={{ once: true }}
                            ></motion.div>
                            <motion.p
                                className="max-w-2xl mx-auto text-gray-300 mt-4"
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                transition={{ duration: 0.8, delay: 0.4 }}
                                viewport={{ once: true }}
                            >
                                Partner with us to create an exceptional experience for students and the startup community
                            </motion.p>
                        </div>

                        <motion.div
                            className="bg-[#ffffff08] backdrop-blur-sm rounded-xl p-8 md:p-10 shadow-2xl border border-[#ffffff10]"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7 }}
                            viewport={{ once: true }}
                        >
                            <h3 className="text-2xl font-bold text-white mb-8 text-center md:text-left">We are requesting:</h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                                <motion.div
                                    className="flex items-start group"
                                    whileHover={{ x: 5 }}
                                    transition={{ type: "spring", stiffness: 400 }}
                                >
                                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#6464ad] to-[#afadd5]/70 flex items-center justify-center text-white mr-4 flex-shrink-0 shadow-lg group-hover:shadow-[#6464ad]/40 transition-shadow duration-300">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 12L10 17L19 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-white text-xl">Venue Permission</p>
                                        <p className="text-gray-300 mt-1">(Open Ground, Auditorium, Halls)</p>
                                    </div>
                                </motion.div>

                                <motion.div
                                    className="flex items-start group"
                                    whileHover={{ x: 5 }}
                                    transition={{ type: "spring", stiffness: 400 }}
                                >
                                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#6464ad] to-[#afadd5]/70 flex items-center justify-center text-white mr-4 flex-shrink-0 shadow-lg group-hover:shadow-[#6464ad]/40 transition-shadow duration-300">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 12L10 17L19 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-white text-xl">AV and basic <span className="text-[#afadd5]">logistics</span> support</p>
                                    </div>
                                </motion.div>

                                <motion.div
                                    className="flex items-start group"
                                    whileHover={{ x: 5 }}
                                    transition={{ type: "spring", stiffness: 400 }}
                                >
                                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#6464ad] to-[#afadd5]/70 flex items-center justify-center text-white mr-4 flex-shrink-0 shadow-lg group-hover:shadow-[#6464ad]/40 transition-shadow duration-300">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 12L10 17L19 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-white text-xl">Accommodation/help for outstation guests</p>
                                    </div>
                                </motion.div>

                                <motion.div
                                    className="flex items-start group"
                                    whileHover={{ x: 5 }}
                                    transition={{ type: "spring", stiffness: 400 }}
                                >
                                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#6464ad] to-[#afadd5]/70 flex items-center justify-center text-white mr-4 flex-shrink-0 shadow-lg group-hover:shadow-[#6464ad]/40 transition-shadow duration-300">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 12L10 17L19 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-white text-xl">College-wide circular for open participation</p>
                                    </div>
                                </motion.div>
                            </div>

                            <div className="mt-12 text-center flex flex-col sm:flex-row justify-center items-center gap-4">
                                <motion.button
                                    className="bg-gradient-to-r from-[#6464ad] to-[#afadd5] text-white py-3 px-8 md:px-10 flex items-center justify-center gap-3 shadow-lg cursor-pointer"
                                    whileHover={{
                                        scale: 1.05,
                                        boxShadow: "0 15px 30px rgba(100, 100, 173, 0.4)"
                                    }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <span className="text-white font-bold text-base md:text-lg">Partner With Us</span>
                                    <motion.div
                                        whileHover={{ x: 3 }}
                                        transition={{ type: "spring", stiffness: 400 }}
                                    >
                                        <HiOutlineArrowNarrowRight className="w-5 h-5 text-white" />
                                    </motion.div>
                                </motion.button>

                                <motion.button
                                    className="border-2 border-[#6464ad] text-white py-3 px-8 md:px-10 flex items-center justify-center"
                                    whileHover={{
                                        scale: 1.05,
                                        backgroundColor: "rgba(100, 100, 173, 0.1)",
                                    }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <span className="text-white font-bold text-base md:text-lg">Learn More</span>
                                </motion.button>
                            </div>
                        </motion.div>

                        {/* Bottom decorative dots */}
                        <div className="flex justify-center gap-2 mt-12">
                            <motion.div
                                className="w-2 h-2 rounded-full bg-[#6464ad]"
                                animate={{ scale: [1, 1.5, 1] }}
                                transition={{ duration: 2, repeat: Infinity, delay: 0 }}
                            />
                            <motion.div
                                className="w-2 h-2 rounded-full bg-[#afadd5]"
                                animate={{ scale: [1, 1.5, 1] }}
                                transition={{ duration: 2, repeat: Infinity, delay: 0.3 }}
                            />
                            <motion.div
                                className="w-2 h-2 rounded-full bg-[#d9daee]"
                                animate={{ scale: [1, 1.5, 1] }}
                                transition={{ duration: 2, repeat: Infinity, delay: 0.6 }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Us Section */}
            <div className="w-full bg-gradient-to-b from-black to-[#1a1a1a] py-14 md:py-20 relative overflow-hidden">
                {/* Background decorative elements */}
                <div className="absolute inset-0 z-0 overflow-hidden">
                    <div className="absolute top-0 left-0 w-80 h-80 rounded-full bg-[#6464ad]/10 -translate-x-1/3 -translate-y-1/3"></div>
                    <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-[#6464ad]/5 translate-x-1/3 translate-y-1/3"></div>

                    {/* Animated glowing dots */}
                    <motion.div
                        className="absolute top-1/4 left-1/3 w-3 h-3 rounded-full bg-[#afadd5]"
                        animate={{
                            opacity: [0.2, 0.8, 0.2],
                            scale: [1, 1.3, 1]
                        }}
                        transition={{ duration: 3, repeat: Infinity }}
                    />

                    <motion.div
                        className="absolute bottom-1/3 right-1/4 w-2 h-2 rounded-full bg-[#6464ad]"
                        animate={{
                            opacity: [0.2, 0.7, 0.2],
                            scale: [1, 1.2, 1]
                        }}
                        transition={{ duration: 2.5, repeat: Infinity, delay: 0.5 }}
                    />

                    {/* Grid pattern */}
                    <div className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(#ffffff10 1px, transparent 1px)`,
                            backgroundSize: '30px 30px'
                        }}>
                    </div>

                    {/* Floating animated elements - INCREASED SIZE */}
                    <motion.div
                        className="absolute top-40 right-10 w-20 h-20 md:w-32 md:h-32"
                        animate={{
                            y: [0, -15, 0],
                            rotate: [0, 5, 0]
                        }}
                        transition={{ duration: 6, repeat: Infinity, repeatType: "reverse" }}
                    >
                        <div className="w-full h-full rounded-lg bg-[#6464ad]/10 backdrop-blur-sm border border-[#6464ad]/30 flex items-center justify-center">
                            <FaPhone className="text-[#afadd5] text-3xl md:text-5xl" />
                        </div>
                    </motion.div>

                    <motion.div
                        className="absolute bottom-40 left-10 w-20 h-20 md:w-32 md:h-32"
                        animate={{
                            y: [0, 15, 0],
                            rotate: [0, -5, 0]
                        }}
                        transition={{ duration: 5, repeat: Infinity, repeatType: "reverse", delay: 1 }}
                    >
                        <div className="w-full h-full rounded-lg bg-[#6464ad]/10 backdrop-blur-sm border border-[#6464ad]/30 flex items-center justify-center">
                            <FaEnvelope className="text-[#afadd5] text-3xl md:text-5xl" />
                        </div>
                    </motion.div>
                </div>

                <div className="container mx-auto px-4 relative z-10">
                    <motion.div
                        className="text-center mb-10"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                    >
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">Connect <span className="text-[#6464ad]">With Us</span></h2>
                        <div className="h-1 w-24 bg-gradient-to-r from-[#6464ad] to-[#afadd5] mx-auto"></div>
                        <p className="max-w-2xl mx-auto text-gray-300 mt-4">Have questions about the event? Reach out to our team</p>
                    </motion.div>

                    <div className="max-w-4xl mx-auto">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                            {/* Contact Card 1 - Phone - INCREASED ICON SIZE */}
                            <motion.div
                                className="bg-[#ffffff08] backdrop-blur-sm rounded-xl p-6 border border-[#ffffff10] shadow-xl relative overflow-hidden group"
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.1 }}
                                whileHover={{
                                    y: -10,
                                    boxShadow: "0 20px 30px rgba(100, 100, 173, 0.3)"
                                }}
                            >
                                {/* Background gradient */}
                                <div className="absolute inset-0 bg-gradient-to-br from-[#6464ad]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                {/* Top right corner decoration */}
                                <div className="absolute top-0 right-0 w-20 h-20 overflow-hidden">
                                    <div className="absolute w-full h-full bg-[#6464ad]/20 rotate-45 translate-x-1/2 -translate-y-1/2"></div>
                                </div>

                                <div className="flex flex-col items-center text-center relative">
                                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#6464ad] to-[#afadd5]/70 flex items-center justify-center text-white mb-4 shadow-lg shadow-[#6464ad]/20">
                                        <FaPhone className="text-3xl" />
                                    </div>

                                    <h3 className="text-xl font-bold text-white mb-2">Call Us</h3>
                                    <p className="text-[#afadd5] text-lg font-medium">9891529229</p>

                                    {/* Animated effect */}
                                    <motion.div
                                        className="absolute -bottom-2 left-1/2 w-12 h-1 bg-[#6464ad]/50 -translate-x-1/2"
                                        animate={{ width: ["30%", "60%", "30%"] }}
                                        transition={{ duration: 2, repeat: Infinity }}
                                    />
                                </div>
                            </motion.div>

                            {/* Contact Card 2 - Mentorsity Email - INCREASED ICON SIZE */}
                            <motion.div
                                className="bg-[#ffffff08] backdrop-blur-sm rounded-xl p-6 border border-[#ffffff10] shadow-xl relative overflow-hidden group"
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                                whileHover={{
                                    y: -10,
                                    boxShadow: "0 20px 30px rgba(100, 100, 173, 0.3)"
                                }}
                            >
                                {/* Background gradient */}
                                <div className="absolute inset-0 bg-gradient-to-br from-[#6464ad]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                {/* Top right corner decoration */}
                                <div className="absolute top-0 right-0 w-20 h-20 overflow-hidden">
                                    <div className="absolute w-full h-full bg-[#6464ad]/20 rotate-45 translate-x-1/2 -translate-y-1/2"></div>
                                </div>

                                <div className="flex flex-col items-center text-center relative">
                                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#6464ad] to-[#afadd5]/70 flex items-center justify-center text-white mb-4 shadow-lg shadow-[#6464ad]/20">
                                        <FaEnvelope className="text-3xl" />
                                    </div>

                                    <h3 className="text-xl font-bold text-white mb-2">Mentorsity Email</h3>
                                    <a
                                        href="mailto:gaurang.jindal@mentorsity.com"
                                        className="text-[#afadd5] text-lg font-medium hover:text-white transition-colors"
                                    >
                                        gaurang.jindal@mentorsity.com
                                    </a>

                                    {/* Animated effect */}
                                    <motion.div
                                        className="absolute -bottom-2 left-1/2 w-12 h-1 bg-[#6464ad]/50 -translate-x-1/2"
                                        animate={{ width: ["30%", "60%", "30%"] }}
                                        transition={{ duration: 2, repeat: Infinity, delay: 0.3 }}
                                    />
                                </div>
                            </motion.div>

                            {/* Contact Card 3 - UNTIEUP Email - INCREASED ICON SIZE */}
                            <motion.div
                                className="bg-[#ffffff08] backdrop-blur-sm rounded-xl p-6 border border-[#ffffff10] shadow-xl relative overflow-hidden group"
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.3 }}
                                whileHover={{
                                    y: -10,
                                    boxShadow: "0 20px 30px rgba(100, 100, 173, 0.3)"
                                }}
                            >
                                {/* Background gradient */}
                                <div className="absolute inset-0 bg-gradient-to-br from-[#6464ad]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                {/* Top right corner decoration */}
                                <div className="absolute top-0 right-0 w-20 h-20 overflow-hidden">
                                    <div className="absolute w-full h-full bg-[#6464ad]/20 rotate-45 translate-x-1/2 -translate-y-1/2"></div>
                                </div>

                                <div className="flex flex-col items-center text-center relative">
                                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#6464ad] to-[#afadd5]/70 flex items-center justify-center text-white mb-4 shadow-lg shadow-[#6464ad]/20">
                                        <FaEnvelope className="text-3xl" />
                                    </div>

                                    <h3 className="text-xl font-bold text-white mb-2">UNTIEUP Email</h3>
                                    <a
                                        href="mailto:uniteupngo@gmail.com"
                                        className="text-[#afadd5] text-lg font-medium hover:text-white transition-colors"
                                    >
                                        uniteupngo@gmail.com
                                    </a>

                                    {/* Animated effect */}
                                    <motion.div
                                        className="absolute -bottom-2 left-1/2 w-12 h-1 bg-[#6464ad]/50 -translate-x-1/2"
                                        animate={{ width: ["30%", "60%", "30%"] }}
                                        transition={{ duration: 2, repeat: Infinity, delay: 0.6 }}
                                    />
                                </div>
                            </motion.div>
                        </div>

                        {/* Bottom animated line */}
                        <div className="mt-16 flex justify-center">
                            <motion.div
                                className="h-px w-40 bg-gradient-to-r from-transparent via-[#6464ad] to-transparent"
                                animate={{
                                    width: ['60%', '80%', '60%'],
                                    opacity: [0.3, 0.7, 0.3]
                                }}
                                transition={{ duration: 3, repeat: Infinity }}
                            />
                        </div>

                        {/* Final message */}
                        <motion.div
                            className="mt-8 text-center"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.5, delay: 0.7 }}
                        >
                            <p className="text-gray-300 italic">"Join us for an unforgettable experience at Riseup 2.0!"</p>
                        </motion.div>
                    </div>
                </div>
            </div>

            {/* News and Media Partners */}
            <div className="w-full bg-gradient-to-b from-[#f8f8ff] to-white py-14 md:py-20 relative overflow-hidden">
                {/* Background decorative elements */}
                <div className="absolute inset-0 z-0 overflow-hidden">
                    <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#6464ad]/5"></div>
                    <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-[#afadd5]/10 -translate-x-1/3 translate-y-1/3"></div>

                    {/* Grid pattern */}
                    <div className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(#6464ad10 1px, transparent 1px)`,
                            backgroundSize: '30px 30px'
                        }}>
                    </div>

                    {/* Animated elements */}
                    <motion.div
                        className="absolute top-1/3 right-10 w-3 h-3 rounded-full bg-[#6464ad]/40"
                        animate={{
                            y: [0, -15, 0],
                            opacity: [0.4, 0.7, 0.4]
                        }}
                        transition={{ duration: 4, repeat: Infinity }}
                    />

                    <motion.div
                        className="absolute bottom-1/4 left-20 w-2 h-2 rounded-full bg-[#afadd5]/60"
                        animate={{
                            y: [0, 10, 0],
                            opacity: [0.4, 0.8, 0.4]
                        }}
                        transition={{ duration: 3, repeat: Infinity, delay: 1 }}
                    />
                </div>

                <div className="container mx-auto px-4 relative z-10">
                    <motion.div
                        className="text-center mb-12"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                    >
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-3">News and Media <span className="text-[#6464ad]">Partners</span></h2>
                        <div className="h-1 w-24 bg-gradient-to-r from-[#6464ad] to-[#afadd5] mx-auto"></div>
                        <p className="max-w-2xl mx-auto text-gray-600 mt-4">Leading publications and media houses supporting our mission</p>
                    </motion.div>

                    <div className="max-w-6xl mx-auto px-4 py-10 bg-white rounded-xl shadow-lg relative">
                        {/* Decorative corner elements */}
                        <div className="absolute top-0 left-0 w-16 h-16">
                            <div className="absolute top-0 left-0 w-full h-full border-t-4 border-l-4 border-[#6464ad]/20 rounded-tl-xl"></div>
                        </div>
                        <div className="absolute top-0 right-0 w-16 h-16">
                            <div className="absolute top-0 right-0 w-full h-full border-t-4 border-r-4 border-[#6464ad]/20 rounded-tr-xl"></div>
                        </div>
                        <div className="absolute bottom-0 left-0 w-16 h-16">
                            <div className="absolute bottom-0 left-0 w-full h-full border-b-4 border-l-4 border-[#6464ad]/20 rounded-bl-xl"></div>
                        </div>
                        <div className="absolute bottom-0 right-0 w-16 h-16">
                            <div className="absolute bottom-0 right-0 w-full h-full border-b-4 border-r-4 border-[#6464ad]/20 rounded-br-xl"></div>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 items-center">
                            {/* Media Partner 1 - TOI */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.1 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={toiLogo} alt="TOI" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 2 - Hindustan Times */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={hindustanTimesLogo} alt="Hindustan Times" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 3 - Dainik - LARGER */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.3 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={dainikLogo} alt="Dainik Bhaskar" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 4 - DailyHunt */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.4 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={dailyhuntLogo} alt="DailyHunt" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 5 - Zee */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.5 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={zeeLogo} alt="Zee Business" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 6 - Indian Times */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.6 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={indianTimesLogo} alt="Indian Times" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 7 - Startup */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.7 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={startupLogo} alt="Startup Story" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 8 - QNA */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.8 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={qnaLogo} alt="QnA" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Additional media partners (9-12) with the same styling pattern */}
                            {/* Media Partner 9 - VC */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.9 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={vcLogo} alt="VC" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 10 - ED Times */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 1.0 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={edtimesLogo} alt="ED Times" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 11 - Hello Entrepreneur */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 1.1 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={helloEntrepreneurLogo} alt="Hello Entrepreneur" className="h-full max-h-full object-contain" />
                            </motion.div>

                            {/* Media Partner 12 - ANI News */}
                            <motion.div
                                className="flex items-center justify-center h-28 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 1.2 }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 20px rgba(100, 100, 173, 0.1)"
                                }}
                            >
                                <img src={aniNewsLogo} alt="ANI News" className="h-full max-h-full object-contain" />
                            </motion.div>
                        </div>
                    </div>

                    {/* Decorative bottom element */}
                    <div className="flex justify-center mt-12">
                        <motion.div
                            className="flex flex-col items-center"
                            animate={{ opacity: [0.7, 1, 0.7] }}
                            transition={{ duration: 3, repeat: Infinity }}
                        >
                            <div className="w-px h-8 bg-gradient-to-b from-[#6464ad] to-transparent"></div>
                            <div className="text-[#6464ad] text-sm font-medium mt-2">And more to come</div>
                        </motion.div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default RiseupEvent; 